import React, { useState } from "react";
import styles from "./usecases.module.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

/* import images */
import universalImg from "../../../asset/UniversalAi.png";
import healthcareImg from "../../../asset/Healthcare.png";
import educationImg from "../../../asset/Education.png";
import industrialImg from "../../../asset/Industrial.png";
import codeImg from "../../../asset/CodeOfCunduct.png";
import taxImg from "../../../asset/IncomeTax.png";
import HealthcareBots from "../../healthcare/healthcarebots";
import EducationBot from "../../education/educationbots";
import IndustrialBots from "../../industry/industrybots";

const cards = [
  {
    title: "Healthcare",
    desc: "Manages appointments, patient queries, reminders, and healthcare support workflows.",
    img: healthcareImg,
    key: "healthcare",
    color: "#00ff88",
    icon: "🏥",
  },
  {
    title: "Code of Conduct",
    desc: "Guides users on policies, compliance rules, ethical standards, and internal regulations.",
    img: codeImg,
    key: "codeofconduct",
    color: "#9333ea",
    icon: "📜",
  },
  {
    title: "Income Tax Department",
    desc: "Guides users on policies, compliance rules, ethical standards, and internal regulations.",
    img: taxImg,
    key: "incometaxdept",
    color: "#00b4ff",
    icon: "💰",
  },
  {
    title: "Education",
    desc: "Supports admissions, course inquiries, student assistance, and academic information.",
    img: educationImg,
    key: "education",
    color: "#ff6b6b",
    icon: "🎓",
  },
  {
    title: "Industrial",
    desc: "Assists with operational queries, process guidance, safety, and industrial support.",
    img: industrialImg,
    key: "industrial",
    color: "#ffa500",
    icon: "🏭",
  },
  {
    title: "Universal AIㅤ",
    desc: "Handles general inquiries, task automation, and conversations across multiple industries.",
    img: universalImg,
    key: "universal",
    color: "#00d4ff",
    icon: "🤖",
  },
];

const UseCases = () => {
  const [activeUseCase, setActiveUseCase] = useState(null);
  const [hoveredCard, setHoveredCard] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => setActiveUseCase(null);

  if (activeUseCase === "healthcare")
    return <HealthcareBots onBack={handleBack} />;

  if (activeUseCase === "education")
    return <EducationBot onBack={handleBack} />;

  if (activeUseCase === "industrial")
    return <IndustrialBots onBack={handleBack} />;

  return (
    <div className={styles.useCaseContainer}>
      {/* Tech Background Elements */}
      <div className={styles.techBg}></div>
      <div className={styles.floatingParticles}>
        {[...Array(8)].map((_, i) => (
          <div key={i} className={styles.particle}></div>
        ))}
      </div>

      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          {/* <span className={styles.titleIcon}>🚀</span> */}
          <h2>Hear MeBot AI in Real-World Scenarios.</h2>
          <span className={styles.titleGlow}></span>
        </div>
        {/* <p>Choose a call type to explore how our agents respond</p> */}
        <div className={styles.headerLine}></div>
      </div>

      {/* Cards Grid */}
      <div className={styles.grid}>
        {cards.map((card, index) => (
          <motion.div
            key={card.title}
            className={styles.card}
            onMouseEnter={() => setHoveredCard(card.key)}
            onMouseLeave={() => setHoveredCard(null)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ y: -8 }}
            style={{ "--card-color": card.color }}
          >
            {/* Card Glow Effect */}
            <div
              className={styles.cardGlow}
              style={{ opacity: hoveredCard === card.key ? 1 : 0 }}
            ></div>

            {/* Card Border */}
            <div className={styles.cardBorder}></div>

            {/* Top Row with Icon */}
            <div className={styles.topRow}>
              <div className={styles.iconContainer}>
                <div
                  className={styles.iconGlow}
                  style={{
                    background: `radial-gradient(circle, ${card.color}40, transparent 70%)`,
                  }}
                ></div>
                <div className={styles.iconBox}>
                  <div className={styles.emojiIcon}>{card.icon}</div>
                  <img
                    src={card.img}
                    alt={card.title}
                    className={styles.cardImg}
                  />
                </div>
              </div>

              {/* Text Content */}
              <div className={styles.textBlock}>
                <div className={styles.cardHeader}>
                  <h3>{card.title}</h3>
                  {/* <span className={styles.cardBadge}>AI</span> */}
                </div>
                <p className={styles.textBlock1}>{card.desc}</p>
                {/* <div className={styles.techTags}>
                  <span className={styles.tag}>Neural AI</span>
                  <span className={styles.tag}>Real-time</span>
                </div> */}
              </div>
            </div>

            {/* Try Demo Button */}
            <motion.button
              className={styles.button}
              onClick={() => {
                if (
                  ["universal"].includes(
                    card.key
                  )
                ) {
                  navigate("/comingsoon");
                }
                else if (card.key === "codeofconduct") {
                  navigate("/coc-demo");
                }
                else if (card.key === "incometaxdept") {
                  navigate("/demo-income");
                }
                 else {
                  setActiveUseCase(card.key);
                }
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              /* Inline style removed so CSS takes over */
            >
              <span className={styles.btnIcon} style={{ color: card.color }}>
                ▶
              </span>
              Explore Demo
            </motion.button>

            {/* Connection Points */}
            <div className={styles.connectionPoints}>
              <div className={styles.connectionPoint}></div>
              <div className={styles.connectionPoint}></div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default UseCases;
